export interface Policy {
    id: number
    type: PolicyType
    version: number
    status: PolicyStatus
    content: string
    createdAt: string
    updatedAt: string
}

export enum PolicyType {
    TERMS_OF_SERVICE = 'TERMS_OF_SERVICE',
    PRIVACY_POLICY = 'PRIVACY_POLICY',
    COOKIE_POLICY = 'COOKIE_POLICY',
    LGPD_PRIVACY_NOTICE = 'LGPD_PRIVACY_NOTICE',
    GDPR_POLICY = 'GDPR_POLICY',
    CCPA_POLICY = 'CCPA_POLICY',
    DATA_CONSENT_DECLARATION = 'DATA_CONSENT_DECLARATION',
    NDA = 'NDA',
    SECURITY_POLICY = 'SECURITY_POLICY',
    SERVICE_CONTRACT = 'SERVICE_CONTRACT',
    CODE_OF_CONDUCT = 'CODE_OF_CONDUCT',
    DATA_RETENTION_DISPOSAL_POLICY = 'DATA_RETENTION_DISPOSAL_POLICY',
    REFUND_POLICY = 'REFUND_POLICY',
    RETURN_POLICY = 'RETURN_POLICY',
    SHIPPING_POLICY = 'SHIPPING_POLICY',
    CANCELLATION_POLICY = 'CANCELLATION_POLICY',
    PAYMENT_POLICY = 'PAYMENT_POLICY',
    SUBSCRIPTION_POLICY = 'SUBSCRIPTION_POLICY',
    ACCEPTABLE_USE_POLICY = 'ACCEPTABLE_USE_POLICY',
    COMMUNITY_GUIDELINES = 'COMMUNITY_GUIDELINES',
    DISCLAIMER = 'DISCLAIMER',
    END_USER_LICENSE_AGREEMENT = 'END_USER_LICENSE_AGREEMENT',
    COPYRIGHT_POLICY = 'COPYRIGHT_POLICY',
    TRADEMARK_POLICY = 'TRADEMARK_POLICY',
    THIRD_PARTY_POLICY = 'THIRD_PARTY_POLICY',
    MARKETING_POLICY = 'MARKETING_POLICY',
    EMPLOYEE_PRIVACY_POLICY = 'EMPLOYEE_PRIVACY_POLICY',
    INTERNAL_USE_POLICY = 'INTERNAL_USE_POLICY',
    OTHER = 'OTHER'
}

export enum PolicyStatus {
    PUBLISHED = 'PUBLISHED',
    DRAFT = 'DRAFT',
    IN_ANALYSIS = 'IN_ANALYSIS',
    INACTIVE = 'INACTIVE'
}

export interface CreatePolicyDto {
    type: PolicyType
    version: number
    status?: PolicyStatus
    content: string
}

export interface UpdatePolicyDto {
    version?: number
    status?: PolicyStatus
    content?: string
}